export default __webpack_public_path__ + "static/media/pixel-m1.56212c00.jpg";